import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '../Services/translation';
import { setTosAndDataPrivacy } from '../actions/Bahag.action';
class BahagTerms extends Component {
    constructor(props) {
        super(props);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    handleCheckboxChange(event) {
        const isChecked = event.target.checked;
        this.props.setTosAndDataPrivacy(isChecked);
    }

    render() {
        return (
            <div className="bahag-terms-container">
                <label className="bahag-terms-container--label">
                    <input className="bahag-terms-container--label__input" type="checkbox" onChange={this.handleCheckboxChange}></input>
                    <span className="bahag-terms-container--label__input-box"></span>
                    <div className="bahag-terms-container--text-container wysiwyg">
                        <span>{translate("checkout.bahag.tos.data.text")}
                            <a className="bahag-terms-container--text-container--anchor" href="https://www.bauhaus.info/agb" target="_blank" >{translate("checkout.bahag.terms.tos")}</a>
                            <a className="bahag-terms-container--text-container--anchor" href="https://www.bauhaus.info/datenschutz" target="_blank">{translate("checkout.bahag.terms.data.privacy")}</a>
                        </span>
                    </div>
                </label>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    setTosAndDataPrivacy: (checked) => dispatch(setTosAndDataPrivacy(checked)),
});

export default connect(null, mapDispatchToProps)(BahagTerms);
